const Footer = () => {
	const currentYear = new Date().getFullYear();
	return (
		<div className="text-xs mt-auto px-4 py-3 text-center md:text-left text-white mix-blend-difference" style={{direction: 'ltr'}}>
			<span>© {currentYear}, Made by <b>Sarveno group</b></span> <span className='block md:inline'>for a better web.</span>
		</div>
	)
}

export default Footer;